function admissionsProcess() {
    const admissions = document.querySelector(
        '[data-block="admissions-process"]'
    )
    const clamp = (num, min, max) => Math.min(Math.max(num, min), max)

    if (admissions) {
        const articleWrapper = admissions.querySelector(
            '[data-target="article-wrapper"]'
        )
        const articles = admissions.querySelectorAll('[data-target="article"]')
        const articlesHeader = admissions.querySelectorAll(
            '[data-target="article-header"]'
        )
        const articleIndex = admissions.querySelectorAll(
            '[data-target="index-item"]'
        )
        const lineIndex = admissions.querySelector('[data-target="line-index"]')

        const indexSizes = articleWrapper.getBoundingClientRect()

        let currentArticle

        let scrollProgress =
            (-(window.scrollY * 0.1 - indexSizes.top) / indexSizes.height) * 100

        lineIndex.style.height = `${clamp(scrollProgress, 5, 100)}%`

        articleIndex[0].classList.add('active-article')

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        currentArticle = entry.target.getAttribute('data-id')

                        articleIndex.forEach((item, index) => {
                            if (index !== currentArticle - 1) {
                                item.classList.remove('active-article')
                            }
                        })
                        articleIndex[currentArticle - 1].classList.add(
                            'active-article'
                        )
                    } else {
                    }
                })
            },
            {
                rootMargin: '0px 0px -70% 0px',
            }
        )

        articlesHeader.forEach((header, index) => {
            observer.observe(header)
        })

        window.addEventListener('scroll', (e) => {
            scrollProgress =
                (-(indexSizes.height - window.scrollY) / indexSizes.height) *
                100

            lineIndex.style.height = `${clamp(scrollProgress, 5, 100)}%`
        })
    }
}

export default admissionsProcess
